import React, { useEffect } from 'react';
import UserSubscriptionCard from '../../components/dashboard/UserSubscriptionCard';
import UserTokensPieChart from '../../components/dashboard/UserTokensPieChart';
import UserFilesProcessedBarChart from '../../components/dashboard/UserFilesProcessedBarChart';
import PageMeta from '../../components/common/PageMeta';
import { userTokensService } from '../../services/UserTokensService';
import { userSubscriptionDataService } from '../../services/UserSubscriptionDataService';
import { userFilesReportService } from '../../services/UserFilesReportService';
import { userStateService } from '../../services/UserStateService';

const UserDashboard: React.FC = () => {
  useEffect(() => {
    // Refresh all data on component mount
    const refreshAllData = async () => {
      try {
        await Promise.all([
          userTokensService.refreshTokenInfo(),
          userSubscriptionDataService.refreshSubscriptionData(),
          userFilesReportService.refreshReportData()
        ]);
      } catch (error) {
        console.error('Error refreshing dashboard data:', error);
      }
    };
    
    refreshAllData();
  }, []);
  
  // Get user name for personalized greeting
  const userName = userStateService.getState()?.name || 'User';
  
  return (
    <>
      <PageMeta
        title="Dashboard | PDF Convert One"
        description="PDF Convert One user dashboard showing subscription status, token usage, and file processing statistics"
      />
      
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
          Welcome back{userName && userName !== 'User' ? `, ${userName}` : ''}
        </h1>
        <p className="text-gray-500 dark:text-gray-400 mt-1">
          Here's an overview of your account and activity.
        </p>
      </div>
      
      <div className="grid grid-cols-12 gap-4 md:gap-6">
        {/* Subscription Card - Left Column */}
        <div className="col-span-12 md:col-span-4">
          <UserSubscriptionCard />
        </div>
        
        {/* Token Usage Pie Chart - Right Column */}
        <div className="col-span-12 md:col-span-8">
          <UserTokensPieChart />
        </div>
        
        {/* Files Processed Bar Chart - Full Width */}
        <div className="col-span-12">
          <UserFilesProcessedBarChart />
        </div>
      </div>
      
      {/* Quick Action Buttons */}
      <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-4">
        <a 
          href="/convert" 
          className="p-4 bg-brand-500 hover:bg-brand-600 rounded-lg text-white text-center transition duration-200"
        >
          Convert PDF
        </a>
        <a 
          href="/files" 
          className="p-4 bg-white hover:bg-gray-50 dark:bg-gray-800 dark:hover:bg-gray-700 border border-gray-200 dark:border-gray-700 rounded-lg text-gray-800 dark:text-gray-200 text-center transition duration-200"
        >
          View Files
        </a>
        <a 
          href="/subscription" 
          className="p-4 bg-white hover:bg-gray-50 dark:bg-gray-800 dark:hover:bg-gray-700 border border-gray-200 dark:border-gray-700 rounded-lg text-gray-800 dark:text-gray-200 text-center transition duration-200"
        >
          Manage Subscription
        </a>
        <a 
          href="/profile" 
          className="p-4 bg-white hover:bg-gray-50 dark:bg-gray-800 dark:hover:bg-gray-700 border border-gray-200 dark:border-gray-700 rounded-lg text-gray-800 dark:text-gray-200 text-center transition duration-200"
        >
          Edit Profile
        </a>
      </div>
    </>
  );
};

export default UserDashboard;